"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValuePropsSdkFactory = void 0;
const composeSDKFactories_1 = require("../composeSDKFactories");
const validations_1 = require("../validations");
const changePropsSDKFactory_1 = require("./changePropsSDKFactory");
const _createValuePropsSDKFactory = (valueSanitizer, valueSchema, inputValidator) => api => {
    const { setProps, props, metaData } = api;
    const schemaValidator = validations_1.createCompSchemaValidator(metaData.role);
    return {
        get value() {
            return props.value;
        },
        set value(value) {
            const sanitizedValue = valueSanitizer(value, api);
            const isValid = schemaValidator(sanitizedValue, valueSchema, 'value');
            if (!isValid) {
                return;
            }
            setProps({ value: sanitizedValue });
            inputValidator.validate({
                viewerSdkAPI: api,
                showValidityIndication: true,
            });
        },
    };
};
const createValuePropsSdkFactory = (valueSanitizer, valueSchema, inputValidator) => composeSDKFactories_1.composeSDKFactories(changePropsSDKFactory_1.changePropsSDKFactory, validations_1.withValidation(_createValuePropsSDKFactory(valueSanitizer, valueSchema, inputValidator), {
    type: ['object'],
    properties: {},
}));
exports.createValuePropsSdkFactory = createValuePropsSdkFactory;
//# sourceMappingURL=valuePropsSDKFactory.js.map